import { render } from "./WaitressModal_c.vue?vue&type=template&id=1c803722&scoped=true"
import script from "./WaitressModal_c.vue?vue&type=script&lang=js"
export * from "./WaitressModal_c.vue?vue&type=script&lang=js"

import "./WaitressModal_c.vue?vue&type=style&index=0&id=1c803722&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c803722"

export default script